import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M20.256 18v1.125a3.378 3.378 0 0 1-6.756 0V18a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 .756.75M9.75 15H4.5a.75.75 0 0 0-.75.75v1.125a3.375 3.375 0 0 0 6.75 0V15.75a.75.75 0 0 0-.75-.75M7.125 1.5c-1.091 0-2.15.967-2.981 2.719-1.306 2.754-1.74 6.844.027 9a.75.75 0 0 0 .581.274h4.74a.75.75 0 0 0 .58-.274c1.768-2.156 1.334-6.249.028-9C9.267 2.467 8.21 1.5 7.125 1.5m7.388 14.25h4.739a.75.75 0 0 0 .58-.275c1.768-2.156 1.334-6.248.028-9-.835-1.758-1.894-2.725-2.985-2.725s-2.146.967-2.978 2.719c-1.306 2.754-1.74 6.844.027 9a.75.75 0 0 0 .585.281z"
    }, null, -1)
  ]))]))
}
export default { render: render }